import { useTranslation } from "react-i18next";

import { CUSTOM_CONFIRM_TYPES, CustomConfirm } from "components";
import { useDeleteLocationMutation } from "modules/DMSv3/Settings/components/AddEditLocationModal/hooks";

type DeleteLocationModalProps = {
  dealer_location_id: number | null;
  onCancel: () => void;
  onClose: () => void;
};

export const DeleteLocationModal = ({ dealer_location_id, onCancel, onClose }: DeleteLocationModalProps) => {
  const { t } = useTranslation();

  const { mutateAsync: deleteLocation, isPending: isDeleteLocationPending } = useDeleteLocationMutation();

  const handleDeleteDmsDealer = async () => {
    if (!dealer_location_id) return;
    await deleteLocation(dealer_location_id);
    onClose();
  };

  return (
    <CustomConfirm
      type={CUSTOM_CONFIRM_TYPES.Danger}
      isOpen={dealer_location_id !== null}
      handleCancel={onCancel}
      customTitle={t("v8_are_you_sure", "Are you sure?")}
      confirmMsg={t("v8_delete_confirm_message", "Are you sure that you want to delete this? You can't undo this action.")}
      handleConfirm={handleDeleteDmsDealer}
      isLoading={isDeleteLocationPending}
    />
  );
};
